// Utility to avoid duplicated errors on redirects to Error view

const ERROR_FLAG_KEY = 'error_already_reported'

export function markErrorAsReported(errorId = null) {
  try {
    const timestamp = Date.now()
    sessionStorage.setItem(ERROR_FLAG_KEY, JSON.stringify({
      reported: true,
      errorId: errorId || `err_${timestamp}`,
      timestamp
    }))
  } catch (e) {}
}

export function hasRecentlyReportedError(timeWindow = 10000) {
  try {
    const storedFlag = sessionStorage.getItem(ERROR_FLAG_KEY)
    if (!storedFlag) return false

    const errorData = JSON.parse(storedFlag)
    const isRecent = errorData.timestamp &&
      (Date.now() - errorData.timestamp < timeWindow)

    return errorData.reported && isRecent
  } catch (e) {
    return false
  }
}

export function clearErrorFlag() {
  try {
    sessionStorage.removeItem(ERROR_FLAG_KEY)
  } catch (e) {}
}
